var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"float-md-right"},[_vm._v("Version "+_vm._s(_vm.version)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }